import React, { useState, useEffect, useRef } from "react";
import videoSrc from "../../assets/reel.mp4";
import "./styles.css";

// Importa le icone di MUI
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const LazyLoadVideo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMuted, setIsMuted] = useState(true); // Stato per controllare l'audio
  const videoRef = useRef(null); // Ref per accedere all'elemento video

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 } // L'elemento deve essere visibile per il 50%
    );

    const videoElement = document.getElementById("video-reel");
    if (videoElement) {
      observer.observe(videoElement);
    }

    return () => {
      if (videoElement) {
        observer.unobserve(videoElement);
      }
    };
  }, []);

  const toggleMute = () => {
    setIsMuted((prevMuted) => !prevMuted); // Inverte lo stato "muted"
    if (videoRef.current) {
      videoRef.current.muted = !isMuted; // Imposta lo stato dell'audio sul video
    }
  };

  return (
    <div id="video-reel" style={{ position: "relative" }}>
      {isVisible && (
        <>
          <video
            onClick={toggleMute}
            ref={videoRef} // Usa ref per accedere al video
            className="video"
            width="100%"
            height="auto"
            preload="auto"
            autoPlay
            loop
            muted={isMuted} // Usa lo stato "muted"
            playsInline
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Icona del volume */}
          <div
            style={{
              position: "absolute",
              bottom: "10px", // Distanza dal fondo
              left: "10px", // Distanza dal lato sinistro
              color: "white", // Colore dell'icona
              cursor: "pointer", // Cambia il cursore quando si passa sopra l'icona
            }}
            onClick={toggleMute}
          >
            {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
          </div>
        </>
      )}
    </div>
  );
};

export default LazyLoadVideo;
